import React from 'react';
import { Link } from 'react-router-dom';

const QuickActions = ({
  regStatus,
  licenseStatus,
  hasLicenseCertificate,
  licenseId,
  onDownloadCertificate,
  onPayment,
  paymentStatus
}) => {
  // Normalize license status for case-insensitive comparison
  const licenseStatusLower = licenseStatus?.toLowerCase();

  // Certificate download requires: approved license status AND certificate actually issued
  const canDownloadCert = licenseStatusLower === 'approved' && hasLicenseCertificate;
  const isPhysicalCert = licenseStatusLower === 'approved' && !hasLicenseCertificate;
  const canRenew = licenseStatusLower === 'approved' && licenseId;
  const needsPayment = licenseStatusLower === 'pending' &&
    (paymentStatus === 'uninitialized' ||
     paymentStatus === 'initialized' ||
     paymentStatus === 'pending_payment');

  const actions = [
    {
      id: 'download',
      icon: isPhysicalCert ? 'storefront' : 'download',
      label: isPhysicalCert ? 'Collect at Office' : 'Download Certificate',
      disabled: !canDownloadCert,
      onClick: canDownloadCert ? onDownloadCertificate : undefined,
      title: isPhysicalCert
        ? 'Your certificate was issued physically. Collect at NiCFoST Office: No. 11 Dire Dawa Street, Wuse Zone 6, Abuja.'
        : undefined
    },
    {
      id: 'history',
      icon: 'history',
      label: 'License History',
      to: '/license-history'
    },
    {
      id: 'renew',
      icon: 'autorenew',
      label: 'Renew License',
      disabled: !canRenew,
      to: canRenew ? `/new-renew-license/${licenseId}` : undefined
    },
    {
      id: 'payment',
      icon: 'credit_card',
      label: needsPayment ? 'Pay Now' : 'Payments',
      to: needsPayment ? undefined : '/payments',
      onClick: needsPayment ? onPayment : undefined,
      highlight: needsPayment
    }
  ];

  return (
    <div className="quick-actions-section">
      <h3 className="section-title">Quick Actions</h3>
      <div className="quick-actions">
        {actions.map((action) => {
          const ButtonContent = (
            <>
              <div className="action-icon">
                <i className="material-icons">{action.icon}</i>
              </div>
              <span className="action-label">{action.label}</span>
            </>
          );

          if (action.to && !action.disabled) {
            return (
              <Link
                key={action.id}
                to={action.to}
                className={`quick-action-btn ${action.highlight ? 'highlight' : ''}`}
                title={action.title}
              >
                {ButtonContent}
              </Link>
            );
          }

          return (
            <button
              key={action.id}
              onClick={action.onClick}
              disabled={action.disabled}
              className={`quick-action-btn ${action.highlight ? 'highlight' : ''}`}
              title={action.title}
            >
              {ButtonContent}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default QuickActions;
